import React, {useRef} from 'react';
import appartement from '../../../../assets/images/svg/090-flats.svg';
import maison from '../../../../assets/images/svg/069-home.svg';
import palace from '../../../../assets/images/svg/093-palace.svg';
import hotel from '../../../../assets/images/svg/087-hotel.svg';
import peniche from '../../../../assets/images/svg/091-house-2.svg';
import divers from '../../../../assets/images/svg/092-camping-tent.svg';
import residenceSenior from "../../../../assets/images/svg/147-senior-residence.svg";


import countryTranslation from 'i18n-iso-countries';
import french from 'i18n-iso-countries/langs/fr.json';

import {RegexFields} from '../../../../constants/utils/regexFields';
import { PostalCityInput } from "../../../../_common/postalCityInput";


export const ResidenceForm = ({personalData, setPersonalData}) => {
    const assetForm = useRef();
    countryTranslation.registerLocale(french);
	const childrenForm = useRef(null);

	return (
		<section className="block mt-2 pt-2">
			<h4 className="h4 text-uppercase text-secondary font-weight-bolder mt-2 mb-1">COORDONNÉES *</h4>
			<form className="py-sm" noValidate ref={assetForm} id="ResidenceForm">
				<div className="d-block mb-3">
					<h5 className="h5 text-uppercase font-weight-bolder mb-2">TYPE DE BIEN</h5>
					<div className="form-inline mb-4">
						<div className="custom-control custom-radio custom-control-inline mr-6">
							<input type="radio" id="Propriétaire" name="bientype" className="custom-control-input" checked={personalData.userResidenceAddress.addressContract === 1} onChange={() => setPersonalData({ ...personalData, userResidenceAddress: { ...personalData.userResidenceAddress, addressContract: 1 } })} />
							<label className="custom-control-label" htmlFor="Propriétaire">
								Propriétaire
							</label>
						</div>
						<div className="custom-control custom-radio custom-control-inline mr-6">
							<input type="radio" id="Locataire" name="bientype" className="custom-control-input" checked={personalData.userResidenceAddress.addressContract === 2} onChange={() => setPersonalData({ ...personalData, userResidenceAddress: { ...personalData.userResidenceAddress, addressContract: 2 } })} />
							<label className="custom-control-label" htmlFor="Locataire">
								Locataire
							</label>
						</div>
						<div className="custom-control custom-radio custom-control-inline">
							<input type="radio" id="Autre" name="bientype" className="custom-control-input" checked={personalData.userResidenceAddress.addressContract === 3} onChange={() => setPersonalData({ ...personalData, userResidenceAddress: { ...personalData.userResidenceAddress, addressContract: 3 } })} />
							<label className="custom-control-label" htmlFor="Autre">
								Autre
							</label>
						</div>
					</div>
					<div className={"invalid-feedback alert-danger alert"}>Veuillez choisir une option</div>
				</div>
				<div className="d-block mb-3">
					<h5 className="h5 text-uppercase font-weight-bolder mb-2">type de bien immobilier</h5>
					<div className="form-row">
						<div className={"form-group col col-lg-4 col-xl-2"}>
							<div className={"card card-body text-center picker-card" + (personalData.userResidenceAddress.addressType === 1 ? " active" : "")} onClick={() => setPersonalData({ ...personalData, userResidenceAddress: { ...personalData.userResidenceAddress, addressType: 1 } })}>
								<img className="img-fluid mx-auto my-3 mb-2 h-6" src={appartement} alt="appartement" />
								<h2 className="h6 font-weight-bolder text-uppercase mb-auto">appartement</h2>
							</div>
						</div>
						<div className={"form-group col col-lg-4 col-xl-2"}>
							<div className={"card card-body text-center picker-card" + (personalData.userResidenceAddress.addressType === 2 ? " active" : "")} onClick={() => setPersonalData({ ...personalData, userResidenceAddress: { ...personalData.userResidenceAddress, addressType: 2 } })}>
								<img className="img-fluid mx-auto my-3 mb-2 h-6" src={maison} alt="maison" />
								<h2 className="h6 font-weight-bolder text-uppercase mb-auto">Maison</h2>
							</div>
						</div>
						{/* <div className={"form-group col col-lg-4 col-xl-2"}>
							<div className={"card card-body text-center picker-card" + (personalData.userResidenceAddress.addressType === 3 ? " active" : "")} onClick={() => setPersonalData({ ...personalData, userResidenceAddress: { ...personalData.userResidenceAddress, addressType: 3 } })}>
								<img className="img-fluid mx-auto my-3 mb-2 h-6" src={palace} alt="palace" />
								<h2 className="h6 font-weight-bolder text-uppercase mb-auto">château</h2>
							</div>
						</div> */}
						<div className={"form-group col col-lg-4 col-xl-2"}>
							<div className={"card card-body text-center picker-card" + (personalData.userResidenceAddress.addressType === 7 ? " active" : "")} onClick={() => setPersonalData({ ...personalData, userResidenceAddress: { ...personalData.userResidenceAddress, addressType: 7 } })}>
								<img className="img-fluid mx-auto my-3 mb-2 h-6" src={residenceSenior} alt="senior residence" />
								<h2 className="h6 font-weight-bolder text-uppercase mb-auto">Résidence Senior</h2>
							</div>
						</div>
						<div className={"form-group col col-lg-4 col-xl-2"}>
							<div className={"card card-body text-center picker-card" + (personalData.userResidenceAddress.addressType === 4 ? " active" : "")} onClick={() => setPersonalData({ ...personalData, userResidenceAddress: { ...personalData.userResidenceAddress, addressType: 4 } })}>
								<img className="img-fluid mx-auto my-3 mb-2 h-6" src={hotel} alt="hotel" />
								<h2 className="h6 font-weight-bolder text-uppercase mb-auto">Hôtel</h2>
							</div>
						</div>
						<div className={"form-group col col-lg-4 col-xl-2"}>
							<div className={"card card-body text-center picker-card" + (personalData.userResidenceAddress.addressType === 5 ? " active" : "")} onClick={() => setPersonalData({ ...personalData, userResidenceAddress: { ...personalData.userResidenceAddress, addressType: 5 } })}>
								<img className="img-fluid mx-auto my-3 mb-2 h-6" src={peniche} alt="peniche" />
								<h2 className="h6 font-weight-bolder text-uppercase mb-auto">Péniche</h2>
							</div>
						</div>
						<div className={"form-group col col-lg-4 col-xl-2"}>
							<div
								className={"card card-body text-center picker-card" + (personalData.userResidenceAddress.addressType === 6 || personalData.userResidenceAddress.addressType === 3 ? " active" : "")}
								onClick={() => setPersonalData({ ...personalData, userResidenceAddress: { ...personalData.userResidenceAddress, addressType: 6 } })}>
								<img className="img-fluid mx-auto my-3 mb-2 h-6" src={divers} alt="divers" />
								<h2 className="h6 font-weight-bolder text-uppercase mb-auto">divers</h2>
								{/* <p className="small o-50 mt-0 mb-auto lh-copy">Château, péniche...</p> */}
							</div>
						</div>
						<div className={"invalid-feedback alert-danger alert"}>Veuillez choisir une option</div>
					</div>
					<div className="form-row">
						<div className="form-group col-12 col-sm-6">
							<label className="h6 font-weight-bolder my-auto" htmlFor="Adresse">
								Adresse
							</label>
							<input
								required
								type="text"
								className="form-control"
								id="Adresse"
								defaultValue={personalData.userResidenceAddress.addressLine1}
								onChange={(event) => {
									setPersonalData({ ...personalData, userResidenceAddress: { ...personalData.userResidenceAddress, addressLine1: event.target.value } });
								}}
							/>
						</div>
						<PostalCityInput
							postalCode={personalData.userResidenceAddress.postalCode}
							city={personalData.userResidenceAddress.city}
							onChange={(updatedAddress) => setPersonalData({ ...personalData, userResidenceAddress: { ...personalData.userResidenceAddress, postalCode: updatedAddress.postalCode, city: updatedAddress.city } })}
							hasWrapper={false}
							country={personalData.userResidenceAddress.country}
							customClasses={{ city: "form-group col-12 col-sm col-xl", postalCode: "form-group col-12 col-sm col-xl" }}
						/>
						{/* <div className="form-group col-12 col-sm col-xl">
							<label className="h6 font-weight-bolder my-auto" htmlFor="Postal">
								Code Postal
							</label>
							{personalData.userResidenceAddress.country === null || personalData.userResidenceAddress.country === "FR" || personalData.userResidenceAddress.country === "GF" || personalData.userResidenceAddress.country === "PF" || personalData.userResidenceAddress.country === "TF" ? (
								<input
									required
									type="text"
									className="form-control"
									id="Postal"
									value={personalData.userResidenceAddress.postalCode}
									onChange={(event) => {
										setPersonalData({ ...personalData, userResidenceAddress: { ...personalData.userResidenceAddress, postalCode: event.target.value } });
									}}
									pattern={RegexFields.frenchZipCode}
								/>
							) : (
								<input
									required
									type="text"
									className="form-control"
									id="Postal"
									value={personalData.userResidenceAddress.postalCode}
									onChange={(event) => {
										setPersonalData({ ...personalData, userResidenceAddress: { ...personalData.userResidenceAddress, postalCode: event.target.value } });
									}}
								/>
							)}
						</div>
						<div className="form-group col-12 col-sm col-xl">
							<label className="h6 font-weight-bolder my-auto" htmlFor="Ville">
								Ville
							</label>
							<input
								required
								type="text"
								className="form-control"
								id="Ville"
								defaultValue={personalData.userResidenceAddress.city}
								onChange={(event) => {
									setPersonalData({ ...personalData, userResidenceAddress: { ...personalData.userResidenceAddress, city: event.target.value } });
								}}
								pattern={RegexFields.nameWithoutNumbers}
							/>
						</div> */}
						<div className="form-group col-12 col-sm col-xl">
							<label className="h6 font-weight-bolder my-auto" htmlFor="Pays">
								Pays
							</label>
							<select
								className="custom-select"
								id="naturalite"
								value={personalData.userResidenceAddress.country}
								onChange={(event) => {
									setPersonalData({ ...personalData, userResidenceAddress: { ...personalData.userResidenceAddress, country: event.target.value } });
								}}>
								{Object.values(countryTranslation.getNames("fr", { select: "official" }))
									.sort()
									.map((countryName) => {
										const countryCode = countryTranslation.getAlpha2Code(countryName, "fr");
										return (
											<option key={countryCode} value={countryCode}>
												{countryName}
											</option>
										);
									})}
							</select>
						</div>
					</div>
					<div className="form-row">
						<div className="form-group col-12 col-lg-3">
							<label className="h6 font-weight-bolder my-auto" htmlFor="Téléphone">
								Téléphone fixe
							</label>
							<input
								type="tel"
								className="form-control"
								id="Téléphone"
								placeholder="00 00 00 00 00"
								defaultValue={personalData.userResidenceAddress.phoneNumber}
								onChange={(event) => {
									setPersonalData({ ...personalData, userResidenceAddress: { ...personalData.userResidenceAddress, phoneNumber: event.target.value } });
								}}
								pattern={RegexFields.frenchPhoneNumber}
							/>
						</div>
						{/* <div className="form-group col-12 col-lg-3">
                        <label className="h6 font-weight-bolder my-auto" htmlFor="mobile">Téléphone mobile</label>
                        <input type="tel" className="form-control" id="mobile" placeholder="00 00 00 00 00" defaultValue={asset.mobile} required onChange={(event) => {
                            setAsset({ ...asset, mobile: event.target.value })
                        }} pattern={RegexFields.frenchPhoneNumber} />
                    </div> */}
					</div>
				</div>
			</form>
		</section>
	);
}